import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import PersonalDataModal from "../Components/Modals/PersonalDataModal";

type Props = NativeStackScreenProps<RootStackParamList, "PersonalData">;

const PersonalDataScreen: React.FC<Props> = ({ navigation }) => {
  return <PersonalDataModal onClose={() => navigation.goBack()} />;
};

export default PersonalDataScreen;
